(() => {
  'use strict';
  const configNode = document.getElementById('sw-catalog');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const products = config.products.filter(p => p.id && p.variants.length);
  const labels = config.labels || {};
  const label = key => escape(labels[key] || key);
  const root = (config.root || '/').replace(/\/?$/, '/');
  const money = value => new Intl.NumberFormat('en-US', {style:'currency', currency:config.currency || 'USD'}).format(value / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const imageUrl = (url, width = 500) => url ? `${url}${url.includes('?') ? '&' : '?'}width=${width}` : '';
  const findProduct = id => products.find(p => String(p.id) === String(id));
  const findVariant = (p, id) => p?.variants.find(v => String(v.id) === String(id));
  const finish = title => title.replace(/\s*\/\s*(USB|500ml)$/i, '').replace(/rechargeable/i, 'Rechargeable').replace('Gradually Varied Pink','Gradient Pink');
  const photoFor = (p, v) => {
    if (p.key === 'portable') return v.image || p.images[0];
    if (p.key === 'electric') return p.images[/^black/i.test(v.title) ? 1 : 0];
    if (p.key === 'scale') return p.images[0];
    if (p.key === 'bottle' && /^black/i.test(v.title)) return p.images[0];
    if (p.key === 'bottle' && /^blue/i.test(v.title)) return p.images[4];
    if (p.key === 'manual' && /gray/i.test(v.title)) return p.images[0];
    return v.image || p.images[0];
  };
  const dialog = document.getElementById('sw-cart');
  if (!dialog) return;
  const content = dialog.querySelector('[data-sw-cart-content]');
  const footer = dialog.querySelector('[data-sw-cart-footer]');
  const cartError = dialog.querySelector('[data-sw-cart-error]');
  let cart = null, busy = false, opener = null, previousOverflow = '';
  let bundles = [], lastAddedProductId = null;
  const request = async (path, body) => {
    const response = await fetch(root + path, {method:body ? 'POST' : 'GET', credentials:'same-origin', headers:{'Accept':'application/json', ...(body ? {'Content-Type':'application/json'} : {})}, ...(body ? {body:JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'We could not update your bag. Please try again.');
    return data;
  };
  const showError = (node, message) => { node.textContent = message; node.hidden = !message; };
  const openCart = () => {
    if (!dialog.open) {
      opener = document.activeElement;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      dialog.querySelector('[data-sw-close-cart]').focus();
    }
  };
  const closeCart = () => dialog.close();
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    if (opener?.isConnected) opener.focus();
  });
  dialog.addEventListener('click', e => { if (e.target === dialog) closeCart(); });
  const eligibleQuantity = () => cart.items.reduce((n, item) => n + (findProduct(item.product_id)?.discountEligible !== false && findVariant(findProduct(item.product_id), item.variant_id) ? item.quantity : 0), 0);
  const selectedFor = p => {
    const inBag = cart.items.find(i => Number(i.product_id) === p.id);
    return findVariant(p, inBag?.variant_id) || p.variants.find(v => v.available);
  };
  const inBag = p => cart.items.some(item => Number(item.product_id) === p.id && findVariant(p, item.variant_id));
  const makeBundles = () => {
    const byKey = key => products.find(p => p.key === key);
    const portable = byKey('portable'), scale = byKey('scale'), bottle = byKey('bottle');
    const anchor = findProduct(lastAddedProductId) || findProduct(cart.items[0]?.product_id);
    const grinder = anchor?.key === 'manual' || (byKey('manual') && inBag(byKey('manual')) && !inBag(byKey('electric'))) ? byKey('manual') : byKey('electric');
    let sets;
    if (anchor?.key === 'portable' || anchor?.key === 'bottle' || (portable && inBag(portable))) {
      sets = [{name:labels.portable_pair, products:[portable,bottle], best:true}, {name:labels.portable_trio, products:[portable,bottle,scale]}];
    } else {
      const partner = anchor?.key === 'bottle' ? bottle : scale;
      sets = [{name:labels.routine, products:[grinder,scale,bottle],best:true}, {name:partner === bottle ? labels.daily_duo : labels.ground_duo,products:[grinder,partner]}];
    }
    const seen = new Set();
    return sets.filter(set => set.products.every(Boolean)).map(set => ({...set, missing:set.products.filter(p => !inBag(p)), choices:Object.fromEntries(set.products.map(p => [p.id, selectedFor(p)?.id]))})).filter(set => {
      if (!set.missing.length || !set.products.some(inBag) || set.products.some(p => !selectedFor(p))) return false;
      const key = set.missing.map(p => p.id).sort().join(',');
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };
  const setPrices = set => {
    const eligible = eligibleQuantity() + set.missing.filter(p => p.discountEligible !== false).length;
    const rate = eligible >= 3 ? .08 : eligible === 2 ? .05 : 0;
    const regular = set.products.reduce((n,p) => n + findVariant(p,set.choices[p.id]).price,0);
    const total = set.products.reduce((n,p) => {const price = findVariant(p,set.choices[p.id]).price; return n + price - (p.discountEligible !== false ? Math.round(price * rate) : 0);},0);
    return {regular,total};
  };
  const renderBundle = (set, index) => {
    const prices = setPrices(set);
    return `<article class="sw-bundle${set.best ? ' sw-bundle--best' : ''}" data-sw-bundle-card="${index}">
      <span class="sw-bundle__badge">${label(set.best ? 'recommended' : 'curated')}</span><h4>${escape(set.name)}</h4>
      <div class="sw-bundle__rows">${set.products.map(p => {
        const chosen = findVariant(p,set.choices[p.id]);
        const present = cart.items.filter(i => Number(i.product_id) === p.id);
        return `<div class="sw-bundle__row${present.length ? ' sw-bundle__row--in-cart' : ''}" data-sw-set-product="${p.id}"><img src="${escape(imageUrl(photoFor(p,chosen),180))}" alt="${escape(p.short + ' — ' + finish(chosen.title))}" width="48" height="54" loading="lazy"><div><strong>${escape(p.short)}</strong>${present.length ? `<span class="sw-in-cart">✓ ${label('already')}</span><small>${present.map(i => escape(finish(i.variant_title || '') + ' · ' + labels.included_qty + ' ' + i.quantity)).join('; ')}</small>` : `<label class="sw-bundle__finish">${label('finish')}<select data-sw-set-choice="${p.id}" aria-label="${escape(set.name + ': ' + p.short + ' finish')}">${p.variants.filter(v => v.available).map(v => `<option value="${v.id}"${v.id === chosen.id ? ' selected' : ''}>${escape(finish(v.title))} · ${money(v.price)}</option>`).join('')}</select></label>`}</div></div>`;
      }).join('')}</div>
      <div class="sw-bundle__price"><small>${label('set_total')}</small><strong data-sw-set-total>${money(prices.total)}</strong>${prices.total < prices.regular ? `<s data-sw-set-regular>${money(prices.regular)}</s>` : ''}</div>
      <button type="button" class="sw-button${set.best ? '' : ' sw-button--light'}" data-sw-complete="${index}">${label('add_missing')} (${set.missing.length})</button>
      <p class="sw-fine">${label('set_detail')}</p>
    </article>`;
  };
  const renderCart = () => {
    if (!cart) return;
    document.querySelectorAll('[data-sw-count]').forEach(node => {node.textContent = cart.item_count;});
    showError(cartError, '');
    if (!cart.item_count) {
      bundles = [];
      content.innerHTML = `<div class="sw-empty"><p class="sw-kicker">A better coffee routine starts here</p><h3>Your bag is waiting.</h3><p>Take your next coffee break somewhere new.</p><a class="sw-button" href="${escape(products.find(p => p.key === 'portable')?.url || root + 'collections/all')}">Explore portable espresso</a></div>`;
      footer.innerHTML = '';
      return;
    }
    const remaining = Math.max(0, 8499-cart.total_price);
    const status = remaining ? `${money(remaining)} away from free U.S. shipping` : 'Free U.S. shipping unlocked';
    bundles = makeBundles();
    content.innerHTML = `<div class="sw-cart__status"><strong>${status}</strong><span>${eligibleQuantity() >= 3 ? '8% set savings' : eligibleQuantity() === 2 ? '5% set savings' : eligibleQuantity() ? 'Build your routine & save' : 'Ready when you are'}</span></div><div class="sw-cart__progress"><span style="width:${Math.min(100,cart.total_price/84.99)}%"></span></div>
      ${bundles.length ? `<section class="sw-upgrades" aria-label="${label('complete')}"><div class="sw-upgrades__heading"><h3>${label('complete')}</h3><span>${label('separate')}</span></div>${bundles.map(renderBundle).join('')}</section>` : ''}
      <h3 class="sw-cart-items-title">${label('your_items')}</h3><div class="sw-cart__items">${cart.items.map(item => {
        const p = findProduct(item.product_id), v = findVariant(p,item.variant_id);
        const src = p && v ? photoFor(p,v) : item.image;
        return `<article class="sw-line"><a href="${escape(item.url)}" tabindex="-1"><img src="${escape(imageUrl(src,180))}" alt="${escape(p?.short || item.product_title)}" width="66" height="74"></a>
          <div><h3><a href="${escape(item.url)}">${escape(p?.short || item.product_title)}</a></h3><p>${escape(finish(item.variant_title || ''))}</p>
          <div class="sw-line__controls"><div class="sw-line__qty"><button type="button" data-sw-change="${escape(item.key)}" data-sw-quantity="${item.quantity-1}" aria-label="Decrease ${escape(p?.short || item.product_title)} quantity">−</button><span aria-label="Quantity ${item.quantity}">${item.quantity}</span><button type="button" data-sw-change="${escape(item.key)}" data-sw-quantity="${item.quantity+1}" aria-label="Increase ${escape(p?.short || item.product_title)} quantity">+</button></div><button type="button" class="sw-line__remove" data-sw-change="${escape(item.key)}" data-sw-quantity="0" aria-label="Remove ${escape(p?.short || item.product_title)}">Remove</button></div></div>
          <div class="sw-line__price">${item.original_line_price > item.final_line_price ? `<s>${money(item.original_line_price)}</s>` : ''}${money(item.final_line_price)}</div></article>`;
      }).join('')}</div>
      `;
    footer.innerHTML = `${cart.total_discount > 0 ? `<div class="sw-cart__status"><span>Your savings</span><strong>−${money(cart.total_discount)}</strong></div>` : ''}<div class="sw-cart__total"><span>Subtotal</span><strong>${money(cart.total_price)}</strong></div><p class="sw-fine">${remaining ? '$5.95 standard U.S. shipping below $84.99.' : 'Free standard U.S. shipping.'} Taxes calculated at checkout.</p><a class="sw-button" href="${root}checkout">Secure checkout</a><p class="sw-fine">Secure payment · Tracked delivery · 30-day return window</p>`;
  };
  const refreshCart = async () => { cart = await request('cart.js'); renderCart(); return cart; };
  const setBusy = value => {
    busy = value;
    dialog.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('button:not([data-sw-close-cart]), select').forEach(node => { node.disabled = value; });
  };
  const addItems = async items => {
    await request('cart/add.js', {items});
    // Once added, a failed refresh must never offer to repeat the add request.
    try { await refreshCart(); }
    catch (_) { content.innerHTML = `<div class="sw-empty"><h3>Added to your bag.</h3><p>Your items are saved. Open your bag to review the latest total.</p><a class="sw-button" href="${root}cart">Review your bag</a></div>`; footer.innerHTML = ''; }
  };
  document.addEventListener('click', async e => {
    const open = e.target.closest('[data-sw-open-cart]');
    if (open) { e.preventDefault(); openCart(); try { await refreshCart(); } catch (_) { showError(cartError,'Your bag could not load. Please refresh the page.'); } return; }
    if (e.target.closest('[data-sw-close-cart]')) { closeCart(); return; }
    const change = e.target.closest('[data-sw-change]');
    const complete = e.target.closest('[data-sw-complete]');
    if ((!change && !complete) || busy) return;
    setBusy(true); showError(cartError,'');
    try {
      if (change) { cart = await request('cart/change.js',{id:change.dataset.swChange,quantity:Number(change.dataset.swQuantity)}); renderCart(); }
      else {
        const set = bundles[Number(complete.dataset.swComplete)];
        if (!set) return;
        const items = set.missing.filter(p => !inBag(p)).map(p => ({id:Number(set.choices[p.id]), quantity:1}));
        if (items.length) await addItems(items);
      }
    } catch (error) { showError(cartError,error.message); }
    finally { setBusy(false); }
  });
  dialog.addEventListener('change', e => {
    const select = e.target.closest('[data-sw-set-choice]');
    if (!select) return;
    const card = select.closest('[data-sw-bundle-card]');
    const set = bundles[Number(card.dataset.swBundleCard)];
    set.choices[select.dataset.swSetChoice] = Number(select.value);
    const prices = setPrices(set);
    card.querySelector('[data-sw-set-total]').textContent = money(prices.total);
    const regular = card.querySelector('[data-sw-set-regular]'); if (regular) regular.textContent = money(prices.regular);
    const p = findProduct(select.dataset.swSetChoice);
    const image = card.querySelector(`[data-sw-set-product="${p.id}"] img`);
    image.src = imageUrl(photoFor(p,findVariant(p,select.value)),180);
    image.alt = `${p.short} — ${finish(findVariant(p,select.value).title)}`;
  });
  document.querySelectorAll('[data-sw-product]').forEach(section => {
    const p = findProduct(section.dataset.swProduct);
    const form = section.querySelector('[data-sw-form]');
    if (!p || !form) return;
    const input = form.querySelector('[name="id"]');
    const quantity = form.querySelector('[name="quantity"]');
    const add = form.querySelector('[data-sw-add]');
    const sticky = section.querySelector('[data-sw-sticky]');
    const stickyAdd = section.querySelector('[data-sw-sticky-add]');
    const error = form.querySelector('[data-sw-product-error]');
    const stage = section.querySelector('.sw-gallery__stage img');
    const index = section.querySelector('[data-sw-index]');
    let selected = findVariant(p,input.value) || p.variants.find(v => v.available) || p.variants[0];
    const selectVariant = (variant, updateUrl = true) => {
      selected = variant; input.value = variant.id;
      section.querySelectorAll('[data-sw-variant]').forEach(button => { button.setAttribute('aria-pressed',String(Number(button.dataset.swVariant) === variant.id)); });
      section.querySelector('[data-sw-variant-name]').textContent = finish(variant.title);
      section.querySelector('[data-sw-price]').textContent = money(variant.price);
      section.querySelector('[data-sw-sticky-price]').textContent = money(variant.price);
      section.querySelector('[data-sw-shipping]').textContent = variant.price >= 8499 ? 'Free U.S. shipping' : 'Free U.S. shipping at $84.99';
      add.disabled = !variant.available; stickyAdd.disabled = !variant.available;
      add.innerHTML = `${variant.available ? 'Add to cart' : 'Sold out'}`;
      stickyAdd.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const photo = photoFor(p,variant), photoIndex = p.images.indexOf(photo);
      stage.src = imageUrl(photo,900); stage.alt = `${p.short} — ${finish(variant.title)}`;
      index.textContent = photoIndex >= 0 ? `${String(photoIndex+1).padStart(2,'0')} / ${String(p.images.length).padStart(2,'0')}` : finish(variant.title);
      section.querySelectorAll('[data-sw-photo]').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.swPhoto) === photoIndex)));
      section.dispatchEvent(new CustomEvent('sw:variant-change', {detail:{id:variant.id,title:variant.title}}));
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url); }
    };
    selectVariant(selected,false);
    section.addEventListener('click', e => {
      const variantButton = e.target.closest('[data-sw-variant]');
      if (variantButton && !busy) selectVariant(findVariant(p,variantButton.dataset.swVariant));
      const photoButton = e.target.closest('[data-sw-photo]');
      if (photoButton) {
        const n = Number(photoButton.dataset.swPhoto);
        stage.src = imageUrl(p.images[n],900); stage.alt = `${p.short} — studio photo ${n+1}`;
        index.textContent = `${String(n+1).padStart(2,'0')} / ${String(p.images.length).padStart(2,'0')}`;
        section.querySelectorAll('[data-sw-photo]').forEach(button => button.setAttribute('aria-pressed',String(button === photoButton)));
      }
      const qtyButton = e.target.closest('[data-sw-qty]');
      if (qtyButton) quantity.value = Math.max(1,(Math.floor(Number(quantity.value)) || 1)+Number(qtyButton.dataset.swQty));
    });
    form.addEventListener('submit', async e => {
      e.preventDefault(); e.stopImmediatePropagation();
      if (busy || !selected.available) return;
      setBusy(true); add.disabled = true; stickyAdd.disabled = true; add.textContent = 'Adding…'; showError(error,'');
      try {
        lastAddedProductId = p.id;
        await addItems([{id:selected.id, quantity:Math.max(1,Math.floor(Number(quantity.value)) || 1)}]);
        document.getElementById('sw-cart-title').textContent = 'Added to your bag.';
        openCart(); dialog.querySelector('.sw-cart__scroll').scrollTop = 0;
      } catch (failure) { showError(error,failure.message); }
      finally { setBusy(false); add.disabled = !selected.available; stickyAdd.disabled = !selected.available; add.innerHTML = 'Add to cart'; }
    },true);
    if ('IntersectionObserver' in window) new IntersectionObserver(entries => {sticky.hidden = entries[0].isIntersecting;},{threshold:0}).observe(form);
  });
  document.querySelectorAll('[data-sw-quick-form]').forEach(form => {
    const p = findProduct(form.dataset.swQuickForm);
    if (!p) return;
    const input = form.querySelector('[name="id"]'), button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-sw-quick-error]'), card = form.closest('.q4-card');
    const update = () => {
      const variant = findVariant(p,input.value);
      if (!variant) return;
      button.textContent = `${variant.available ? labels.add : labels.sold_out} · ${money(variant.price)}`;
      button.disabled = !variant.available;
      const badge = form.querySelector('[data-sw-quick-badge]');
      if (badge) {
        const featured = String(variant.id) === input.dataset.swFeaturedVariant;
        badge.hidden = !featured;
        input.classList.toggle('q4-finish-select--featured',featured);
      }
      card.querySelector('.q4-card-title > span').textContent = money(variant.price);
      const image = card.querySelector('.q4-card-image img');
      image.removeAttribute('srcset'); image.src = imageUrl(photoFor(p,variant),750); image.alt = `${p.short} — ${finish(variant.title)}`;
      showError(error,'');
    };
    input.addEventListener('change',update); update();
    form.addEventListener('submit', async e => {
      e.preventDefault(); e.stopImmediatePropagation();
      const variant = findVariant(p,input.value);
      if (busy || !variant?.available) return;
      setBusy(true); button.disabled = true; button.textContent = labels.adding; showError(error,'');
      try {
        lastAddedProductId = p.id;
        await addItems([{id:variant.id,quantity:1}]);
        document.getElementById('sw-cart-title').textContent = labels.saved;
        openCart(); dialog.querySelector('.sw-cart__scroll').scrollTop = 0;
      } catch (failure) { showError(error,failure.message || labels.quick_error); }
      finally { setBusy(false); button.disabled = !variant.available; button.textContent = `${labels.add} · ${money(variant.price)}`; }
    },true);
  });
  refreshCart().catch(() => {});
  if (location.pathname.replace(/\/$/,'') === `${root}cart`.replace(/\/$/,'')) openCart();
  window.addEventListener('pageshow', e => { if (e.persisted) refreshCart().catch(() => {}); });
})();





(() => {
  const group = document.getElementById('header-group');
  if (!group?.querySelector('.sw-header')) return;
  const wrapper = group.closest('.page-wrapper');
  const scroller = wrapper && /auto|scroll/.test(getComputedStyle(wrapper).overflowY) ? wrapper : window;
  const position = () => Math.max(0, scroller === window ? window.scrollY : scroller.scrollTop);
  let previous = position(), travelled = 0, direction = 0, scheduled = false;
  const show = () => group.classList.remove('sw-scroll-header--hidden');
  group.classList.add('sw-scroll-header');
  const update = () => {
    scheduled = false;
    const current = position(), delta = current - previous;
    previous = current;
    if (current <= group.offsetHeight || group.contains(document.activeElement) || document.getElementById('sw-cart')?.open) {
      show(); travelled = 0; return;
    }
    const nextDirection = Math.sign(delta);
    if (!nextDirection) return;
    if (nextDirection !== direction) travelled = 0;
    direction = nextDirection; travelled += Math.abs(delta);
    if (travelled >= 10) { group.classList.toggle('sw-scroll-header--hidden', direction > 0); travelled = 0; }
  };
  scroller.addEventListener('scroll', () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  }, {passive:true});
  group.addEventListener('focusin', show);
})();
